const ANCHOR_HREF_REGEX = /<a\s[^>]*href=["']([^"']+)["'][^>]*>/i;
const ANCHOR_TAG_REGEX = /<\/?a\b[^>]*>/gi;

type BannerLink = {
  url?: string;
  href?: string;
  link?: string;
  ctaLabel?: string;
  message?: string;
};

export const getBannerHref = (
  banner?: BannerLink,
  messageHtml?: string
): string | undefined => {
  if (banner && (banner.url || banner.href || banner.link)) {
    return banner.url || banner.href || banner.link;
  }

  const match = messageHtml && messageHtml.match(ANCHOR_HREF_REGEX);
  return match ? match[1] : undefined;
};

export const stripAnchorTags = (html?: string) =>
  html ? html.replace(ANCHOR_TAG_REGEX, '') : html;

const SECONDS_PER_HOUR = 60 * 60;

export const DEFAULT_COUNTDOWN_WINDOW_HOURS = 24;

export const getCountdownSeconds = (
  secondsRemaining: number,
  countdownWindowHours: number
): number => (
  secondsRemaining > 0 && secondsRemaining <= countdownWindowHours * SECONDS_PER_HOUR
    ? secondsRemaining
    : 0
);
